<template>
    <div>
        <b-skeleton width="100%" height="40px" v-if="!options" animation="throb"/>
        <SelectField v-model="content.spark_name" 
            label="Spark"
            name="spark"
            :items="options"
            :reduce="(o) => o"
            :rules="{required: true}"
            v-else
        />
        <CodeEditor
            v-model="content.expression"
            :label="this.$t('code')"
            :label-cols="2"
            :horizontal="true"
            :controls="false"
            :libs="libs"
            :vars="vars"
            :description="$t('sparkWorkflowExpressionEditor')"
        />
    </div>
</template>

<script>
import InputField from '@/components/form/Input'
import SelectField from '@/components/form/Select'
import CodeEditor from '@/components/form/Editor/Code'

export default {
    components: {
        InputField,
        CodeEditor,
        SelectField
    },
    props: {
        value: {
            type: Object,
            default: function() {
                return {}
            }
        }
    },
    computed: {
        content: {
            get() {
                return this.value;
            },

            set(val) {
                this.$emit('input', val);
            }
        },

        spark: {
            get() {
                return this.content.spark
            },

            set(val) {
                console.log("hello")
                this.content.spark = val
            }
        },

         libs() {
            return [
                {
                    name: "lodash",
                    varName: "_",
                    docs: "https://lodash.com/"
                },
                {
                    name: "moment",
                    varName: "moment",
                    docs: "https://momentjs.com"
                },
                {
                    name: "protokol/component",
                    varName: "component",
                    docs: this.$env.get('DOCS_URL') + "/docs#libs-component"
                },
                {
                    name: "protokol/io",
                    varName: "io",
                    docs: this.$env.get('DOCS_URL')+ "/docs#libs-io"
                },
                {
                    name: "protokol/query",
                    varName: "query",
                    docs: this.$env.get('DOCS_URL') + "/docs#libs-query"
                }
            ]
        },

        vars() {
            return [
                {
                    name: "models",
                    usage: `[ collection of models from event ]`
                },
            ]
        }
    },
    methods: {
        fieldError(error) {
            let found = this.errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        checkForErrors() {
            return this.errors.find((i, e) => {
                return i.error
            })
        }
    },
    data: function() {
        return {
            errors: [],
            options: null
        }
    },

    mounted() { 
        this.$sandbox.spark().all().then(resp => {
            this.options = resp.data.map(d => {
                return d.name
            })
       }).catch(err => {
           console.error(err)
           this.$bvToast.toast(this.$t('unexpectedError'), {
            title: this.$t('error'),
            variant: "danger"
           })
       })
    }
}
</script>
